import {generateAsyncActionCreators} from '../core/reduxUtils';

const getStaticPageActionCreators = generateAsyncActionCreators(
  'GET_STATIC_PAGE_INFO',
  (staticPageId, staticPageKey, params) => ({
    staticPageId,
    staticPageKey,
    params,
  })
);

const actionCreators = {
  getStaticPage: {
    ...getStaticPageActionCreators,
  },
};

export {
  actionCreators,
  getStaticPageActionCreators,
};
